import React, { useState } from 'react';
import { TextField as MTextField } from '@material-ui/core';

const TextField = ({ label, configurations, error, initialValue, handleChange }) => {

  const [value, setValue] = useState(initialValue);

  return (
    <MTextField
      {...configurations}
      fullWidth
      error={error}
      label={label}
      InputLabelProps={{ shrink: true }}
      value={value}
      onChange={(e) => {
        setValue(e.target.value);
        handleChange(e.target.value);
      }}
    />
  );
};

export default TextField;
